import type { RecentEntity } from '../types';

const KEY = 'milpilots.cmdk.recents.v1';
const MAX = 10;

function safeRead(): RecentEntity[] {
    try {
        const raw = window.localStorage.getItem(KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw) as unknown;
        return Array.isArray(parsed) ? (parsed as RecentEntity[]) : [];
    } catch {
        return [];
    }
}

function safeWrite(entries: RecentEntity[]): void {
    try {
        window.localStorage.setItem(KEY, JSON.stringify(entries));
    } catch {
        // Quota exceeded or storage disabled — fail silently.
    }
}

export const recentsStore = {
    load(): RecentEntity[] {
        return safeRead();
    },
    push(entry: Omit<RecentEntity, 'recordedAt'>): RecentEntity[] {
        const now = Date.now();
        const existing = safeRead().filter((e) => !(e.type === entry.type && String(e.id) === String(entry.id)));
        const next = [{ ...entry, recordedAt: now }, ...existing].slice(0, MAX);
        safeWrite(next);
        return next;
    },
    remove(type: RecentEntity['type'], id: RecentEntity['id']): RecentEntity[] {
        const next = safeRead().filter((e) => !(e.type === type && String(e.id) === String(id)));
        safeWrite(next);
        return next;
    },
    clear(): void {
        try {
            window.localStorage.removeItem(KEY);
        } catch {
            // ignore
        }
    },
};
